import React, { Suspense } from "react";
import { BaseScreen } from "./BaseScreen";
import { UsersWhoMadeContentNodeTable } from "../components/published-node-users/UsersWhoMadeContentNodeTable";
import {
	UserWhoMadeContentNodeSearchContainer
} from "../components/published-node-users/UserWhoMadeContentNodeSearchContainer";
import {UserWhoMadeContentNodeFilter} from "../components/published-node-users/UserWhoMadeContentNodeFilter";

export const UsersWhoMadeContentNodeScreen = () => {
	return (
		<BaseScreen>
			<UserWhoMadeContentNodeSearchContainer>
				<UserWhoMadeContentNodeFilter/>
			<Suspense fallback={<div>Lade...</div>}>
				<UsersWhoMadeContentNodeTable />
			</Suspense>
			</UserWhoMadeContentNodeSearchContainer>
		</BaseScreen>
	);
};
